import { render, staticRenderFns } from "./auth-error.vue?vue&type=template&id=dd4ce832&scoped=true&"
import script from "./auth-error.vue?vue&type=script&lang=js&"
export * from "./auth-error.vue?vue&type=script&lang=js&"
import style0 from "./auth-error.vue?vue&type=style&index=0&id=dd4ce832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4ce832",
  null
  
)

export default component.exports